import React from 'react'
import classNames from 'classnames'
import styles from './InfoCard.module.scss'

export interface InfoCardProps {
  label: string
}

export const InfoCard: React.FC<InfoCardProps> = ({ label }) => (
  <div className={classNames(styles.card, 'border d-flex align-items-center gap-3 rounded-3 ps-3 pt-2 pb-2 pe-3')}>
    <span className='flex-grow-1 fw-semibold small'>{label}</span>
    <i className='bi bi-check-lg text-success flex-shrink-0 fs-5' />
  </div>
)
